export default __webpack_public_path__ + "static/media/icon-2.ff4311be.png";